module.exports = __webpack_public_path__ + "static/media/fa-solid-900.ad912fd1.svg";